import {
  EmailIcon,
  SettingsIcon,
  QuestionIcon,
  InfoIcon,
  ChatIcon,
} from '@chakra-ui/icons';
import {
  FaUsers, 
  FaUserFriends, 
  FaHistory, 
  FaEnvelope,
  FaUserCog,
  FaAddressBook,
  FaToolbox,
  FaFileAlt,
  FaEnvelopeOpen,
  FaHome,
  FaUser,
  FaUserShield,
  FaIdCard,
  FaSignOutAlt,
  FaUserPlus,
  FaLock,
  FaFileImport,
} from 'react-icons/fa';
import { FiShield, FiCheckCircle } from 'react-icons/fi';
import { BsCalendar } from 'react-icons/bs';

export const ICON_MAP = {
  'EmailIcon': EmailIcon,
  'SettingsIcon': SettingsIcon,
  'QuestionIcon': QuestionIcon,
  'InfoIcon': InfoIcon,
  'ChatIcon': ChatIcon,
  'FaUsers': FaUsers,
  'FaUserFriends': FaUserFriends,
  'FaHistory': FaHistory,
  'FaEnvelope': FaEnvelope,
  'FaUserCog': FaUserCog,
  'FaAddressBook': FaAddressBook,
  'FaToolbox': FaToolbox,
  'FaFileAlt': FaFileAlt,
  'FaEnvelopeOpen': FaEnvelopeOpen,
  'FaHome': FaHome,
  'FaUser': FaUser,
  'FaUserShield': FaUserShield,
  'FaIdCard': FaIdCard,
  'FaSignOutAlt': FaSignOutAlt,
  'FaUserPlus': FaUserPlus,
  'FaLock': FaLock,
  'FaFileImport': FaFileImport,
  'FiShield': FiShield,
  'FiCheckCircle': FiCheckCircle,
  'BsCalendar': BsCalendar,
};
